import React, { useRef, useEffect, memo } from "react";
import PropTypes from 'prop-types';
const fullGraphUrl = `${document.location.origin}/informacion_de_mercado/cotizacion_emisoras`;

function MarketDataWidget(props) {

  const container = useRef();

  let drawMarketDataWidget = () => {
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-market-quotes.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = `{
      "width": "100%",
      "height": "100%",
      "symbolsGroups": ${JSON.stringify(props.symbolsGroups)},
      "showSymbolLogo": true,
      "isTransparent": false,
      "colorTheme": "light",
      "locale": ${JSON.stringify(props.locale)},
      "largeChartUrl": ${JSON.stringify(props.fullGraphUrl ? props.fullGraphUrl : fullGraphUrl)},
      "customer": "bivacom"
    }`;
    console.log(script.innerHTML);
    container.current.appendChild(script);
  };

  useEffect(() => {
    drawMarketDataWidget();
    console.log();
    //.style.setProperty('width', '130px');
  }, []);

  return (
    <div className={[props.widgetStyle].join(" ")} ref={container} />
  );

}

MarketDataWidget.propTypes = {
  locale: PropTypes.string,
  symbolsGroups: PropTypes.arrayOf(PropTypes.exact({
    name: PropTypes.string,
    symbols: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      displayName: PropTypes.string}))
  })),
  fullGraphUrl: PropTypes.string,
  widgetStyle: PropTypes.string
}

export default memo(MarketDataWidget);
